import { Trans, useTranslation } from "react-i18next";

export function TableHeader({ headerDefs: { header } }) {
  useTranslation();
  return (
    <thead>
      {header?.map((row, index) => {
        let zeile = row.columns.map((col, index2) => {
          if (!(col.visible ?? true)) return null;

          let content = "";
          if (col?.translationKey)
            content = (
              <Trans
                i18nKey={col?.translationKey}
                ns={col?.translationNamespace}
                components={{
                  sub: <sub />,
                  italic: <i />,
                  bold: <strong />,
                  sup: <sup />,
                }}
              />
            );

          return (
            <th key={index2} colSpan={`${col.span ?? 1}`}>
              {content}
            </th>
          );
        });
        return <tr key={index}>{zeile}</tr>;
      })}
    </thead>
  );
}
